export default __webpack_public_path__ + "static/media/logo-you.b0c85671.gif";